
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      router.replace(router.currentRoute.value.fullPath)
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
  }
}
import { default as gXA601jjI_uFqm7UM70sddaAPjcyyvhqhHv4zXB9UVFYMeta } from "/codebuild/output/src123880885/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/g.vue?macro=true";
import { default as index7_574qa1L8Sk5iH2LUV0n3xDupWgn1DEELONunkfw24Meta } from "/codebuild/output/src123880885/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/index.vue?macro=true";
import { default as searchb4y8QGo2mZLCS7xz1c13S2x6bbJCfEWjvfIoe0H2bJIMeta } from "/codebuild/output/src123880885/src/actions-runner/_work/onenews/onenews/web-services/common/pages/search.vue?macro=true";
import { default as indexP0ssXDR6JGNAZRWD1cCgM6hN0_45b6M0E4vr4zz3hItXwMeta } from "/codebuild/output/src123880885/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/v8/index.vue?macro=true";
import { default as _91id_93Hjp2t4F330PioDvfd1n7hEUkESkc00nABlFsx2Ae9jUMeta } from "/codebuild/output/src123880885/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/video/[id].vue?macro=true";
import { default as index8axxjsXeTP3HaerACYCmseZnYMfYXV1_45bJvu0BKD8tAMeta } from "/codebuild/output/src123880885/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/terms/index.vue?macro=true";
import { default as _91id_93RJwROITfkIo1Bt618ExXe1M86VyZScPiJ_viG0wsC3oMeta } from "/codebuild/output/src123880885/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/article/[id].vue?macro=true";
import { default as indexlbn4q4y_wMEjpmRvQqJPUaCOut8U_45Z1suc3D_dxf_45f4Meta } from "/codebuild/output/src123880885/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/contact/index.vue?macro=true";
import { default as _91id_93plnxL_ca2Q0SE_Mkga_D592OzpBpbqpdwx75Rb_8ppEMeta } from "/codebuild/output/src123880885/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/v8/article/[id].vue?macro=true";
import { default as indexw8SRpMrdI_FGkx98aG6f32CnsKMqwx0ZjD4ysZ326rIMeta } from "/codebuild/output/src123880885/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/privacy-policy/index.vue?macro=true";
import { default as index5AO70lF1siRAC55YtwhquPil_ek9HoV1WZy7LHgSeo0Meta } from "/codebuild/output/src123880885/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/privacy-policy/relationships/index.vue?macro=true";
export default [
  {
    name: "g",
    path: "/g",
    component: () => import("/codebuild/output/src123880885/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/g.vue")
  },
  {
    name: "index",
    path: "/",
    component: () => import("/codebuild/output/src123880885/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/index.vue")
  },
  {
    name: "search",
    path: "/search",
    component: () => import("/codebuild/output/src123880885/src/actions-runner/_work/onenews/onenews/web-services/common/pages/search.vue")
  },
  {
    name: "v8",
    path: "/v8",
    component: () => import("/codebuild/output/src123880885/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/v8/index.vue")
  },
  {
    name: "video-id",
    path: "/video/:id()",
    component: () => import("/codebuild/output/src123880885/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/video/[id].vue")
  },
  {
    name: "terms",
    path: "/terms",
    meta: index8axxjsXeTP3HaerACYCmseZnYMfYXV1_45bJvu0BKD8tAMeta || {},
    component: () => import("/codebuild/output/src123880885/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/terms/index.vue")
  },
  {
    name: "article-id",
    path: "/article/:id()",
    component: () => import("/codebuild/output/src123880885/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/article/[id].vue")
  },
  {
    name: "contact",
    path: "/contact",
    meta: indexlbn4q4y_wMEjpmRvQqJPUaCOut8U_45Z1suc3D_dxf_45f4Meta || {},
    component: () => import("/codebuild/output/src123880885/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/contact/index.vue")
  },
  {
    name: "v8-article-id",
    path: "/v8/article/:id()",
    component: () => import("/codebuild/output/src123880885/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/v8/article/[id].vue")
  },
  {
    name: "privacy-policy",
    path: "/privacy-policy",
    meta: indexw8SRpMrdI_FGkx98aG6f32CnsKMqwx0ZjD4ysZ326rIMeta || {},
    component: () => import("/codebuild/output/src123880885/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/privacy-policy/index.vue")
  },
  {
    name: "privacy-policy-relationships",
    path: "/privacy-policy/relationships",
    meta: index5AO70lF1siRAC55YtwhquPil_ek9HoV1WZy7LHgSeo0Meta || {},
    component: () => import("/codebuild/output/src123880885/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/privacy-policy/relationships/index.vue")
  }
]